import {
  postLogin, getMe, patchMe, syncCart, getProductsAuth, getFav,
  getFirms
} from "../../utils/api";
import { deleteAllCookies, setCookie } from "../../utils/cookie";
import { START_LOADING, END_LOADING } from "./loading_actions";
import { RESET_LOGIN_FORM } from "./login_form_actions";
import { SET_PORTAL_API } from "./portal_actions";
import { TEXT_PATCH_ME_SUCCESS, TITLE_ERROR, TITLE_NOTIFICATION } from "../../utils/constants";
import { SYNC_CART_WITH_SERVER } from "./cart_actions";
import { GET_PRODUCTS_SUCCESS } from "./products_actions";
import { GET_FAV_REQUEST_SUCCESS } from "./fav_actions";
import { SET_CUSTOMER } from "./customer_actions";
import { REQUEST_GET_FIRMS_SUCCESS } from "./firms_actions";


export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const REQUEST_LOGIN_SUCCESS = 'REQUEST_LOGIN_SUCCESS';
export const REQUEST_LOGIN_FAILED = 'REQUEST_LOGIN_FAILED';

export const LOGOUT = 'LOGOUT';

export const REQUEST_GET_ME = 'REQUEST_GET_ME';
export const REQUEST_GET_ME_SUCCESS = 'REQUEST_GET_ME_SUCCESS';
export const REQUEST_GET_ME_FAILED = 'REQUEST_GET_ME_FAILED';

export const REQUEST_PATCH_ME = 'REQUEST_PATCH_ME';
export const REQUEST_PATCH_ME_SUCCESS = 'REQUEST_PATCH_ME_SUCCESS';
export const REQUEST_PATCH_ME_FAILED = 'REQUEST_PATCH_ME_FAILED';


export const postLoginThunk = (
  navigate, from, email, password, cart
) => {
  return function (dispatch) {
    dispatch({ type: START_LOADING });
    dispatch({ type: REQUEST_LOGIN });
    postLogin(email, password)
      .then(data => {
        deleteAllCookies();
        setCookie('accessToken', data.access);
        setCookie('refreshToken', data.refresh);
        dispatch({
          type: REQUEST_LOGIN_SUCCESS
        });
        dispatch({ type: RESET_LOGIN_FORM });
        getMe(data.access, data.refresh)
          .then(data => {
            dispatch({
              type: REQUEST_GET_ME_SUCCESS,
              id: data.id,
              first_name: data.first_name,
              last_name: data.last_name,
              surname: data.surname,
              email: data.email,
              phone: data.phone,
              is_active: data.is_active,
              discount_level: data.discount_level,
              role: data.role,
              perm_news: data.perm_news,
              perm_system_messages: data.perm_system_messages,
              last_ship_name: data.last_ship_name,
              last_ship_description: data.last_ship_description,
              pre_last_ship_name: data.pre_last_ship_name,
              pre_last_ship_description: data.pre_last_ship_description
            });
            dispatch({ type: SET_CUSTOMER, customer: data });
            navigate(from?.pathname || "/", { replace: true });
          });
        getProductsAuth(data.access, data.refresh)
          .then(products => {
            dispatch({
              type: GET_PRODUCTS_SUCCESS,
              products
            });
          })
        syncCart(data.access, data.refresh, 'PATCH', cart)
          .then(cartData => {
            dispatch({
              type: SYNC_CART_WITH_SERVER,
              payload: cartData
            });
          });
        getFav(data.access, data.refresh)
          .then(favData => {
            dispatch({
              type: GET_FAV_REQUEST_SUCCESS,
              payload: favData
            });
          });
        getFirms(data.access, data.refresh)
          .then(data => {
            dispatch({
              type: REQUEST_GET_FIRMS_SUCCESS,
              payload: data
            });
          })
      })
      .catch(error => {
        console.log(error);
        const errorText = error?.detail === 'No active account found with the given credentials'
          ? 'Не найдена действующая (активированная) учётная запись для указанных данных'
          : Object.values(error)
        dispatch({ type: REQUEST_LOGIN_FAILED });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: errorText
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}

export const getMeThunk = (accessToken, refreshToken, customer = {}) => {
  return function (dispatch) {
    dispatch({ type: START_LOADING });
    dispatch({ type: REQUEST_GET_ME });
    getMe(accessToken, refreshToken)
      .then(data => {
        dispatch({
          type: REQUEST_GET_ME_SUCCESS,
          id: data.id,
          first_name: data.first_name,
          last_name: data.last_name,
          surname: data.surname,
          email: data.email,
          phone: data.phone,
          is_active: data.is_active,
          discount_level: data.discount_level,
          role: data.role,
          perm_news: data.perm_news,
          perm_system_messages: data.perm_system_messages,
          last_ship_name: data.last_ship_name,
          last_ship_description: data.last_ship_description,
          pre_last_ship_name: data.pre_last_ship_name,
          pre_last_ship_description: data.pre_last_ship_description
        });
        // если кустомер не определён
        if (Object.keys(customer).length <= 0 || customer?.id <= 0) {
          dispatch({ type: SET_CUSTOMER, customer: data });
        }
      })
      .catch(error => {
        dispatch({ type: REQUEST_GET_ME_FAILED });
        console.log(error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}

export const patchMeThunk = (accessToken, refreshToken, data) => {
  return function (dispatch) {
    dispatch({ type: START_LOADING });
    dispatch({ type: REQUEST_PATCH_ME });
    patchMe(accessToken, refreshToken, data)
      .then(data => {
        dispatch({
          type: REQUEST_PATCH_ME_SUCCESS,
          id: data.id,
          first_name: data.first_name,
          last_name: data.last_name,
          surname: data.surname,
          phone: data.phone,
          is_active: data.is_active,
          discount_level: data.discount_level,
          role: data.role,
          perm_news: data.perm_news,
          perm_system_messages: data.perm_system_messages
        });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_NOTIFICATION,
          text: TEXT_PATCH_ME_SUCCESS
        });
      })
      .catch(error => {
        dispatch({ type: REQUEST_PATCH_ME_FAILED });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
        console.log(error);
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}
